import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import style from './FeatureErrorFallback.module.scss?module';
import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons/faTriangleExclamation';

interface Props {
  featureName: string;
  onReset: () => void;
}

export function FeatureErrorFallback({ featureName, onReset }: Props) {
  return (
    <div className={style.Container}>
      <div role="alert" className={style.Box}>
        <div className="d-flex align-items-center justify-content-center gap-2">
          <h1 className={style.Title}>Errors in the: {featureName}</h1>
          <FontAwesomeIcon size="2xl" icon={faTriangleExclamation} bounce />
        </div>

        <p className={style.Message}>
          This function could not be executed correctly. You can try again or
          come back later.
        </p>

        <button className={style.Button} onClick={onReset}>
          Try again
        </button>
      </div>
    </div>
  );
}
